// extracted by mini-css-extract-plugin
module.exports = {"adTitle":"styles_adTitle__US_h0","protectLabel":"styles_protectLabel__xHoyr","urgentJobAdLabel":"styles_urgentJobAdLabel__P3kpi","title":"styles_title__XeY4x"};